export function trim() {
  return function (text: string) {
    const str = text.replace(/\s+/g, "");
    return str.toLowerCase();
  };
}
